import { useEffect, useState } from 'react';

export default function useSubmitMessage(handleSubmit: () => void) {
  const [shouldHandleSubmit, setShouldHandleSubmit] = useState(false);

  /** We need to handle {Enter} separately for remirror.
   *  When passing in an updated `handleSubmit` function directly to remirror, it will not update, it will hold on to the first callback received.
   *  To work around this, we have `triggerSubmit` to directly manipulate a boolean state.
   *  This state is observed using the below `useEffect` hook, which will trigger the callback.
   */
  const triggerSubmit = () => {
    setShouldHandleSubmit(true);
  };

  useEffect(() => {
    if (shouldHandleSubmit) {
      handleSubmit();
      setShouldHandleSubmit(false);
    }
  }, [shouldHandleSubmit]);

  return { triggerSubmit };
}
